import { ApiService } from './../../../services/api/api.service';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { NbAlertModule, NbInputModule, NbButtonModule, NbLayoutModule } from '@nebular/theme';
import { NgIf, NgFor } from '@angular/common';
import { PasswordSetComponent } from '../../../shared-components/password-set/password-set.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'nb-reset-password-page',
    styleUrls: ['./reset-password.component.scss'],
    templateUrl: './reset-password.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NbAlertModule, NgFor, FormsModule, NbInputModule, NbButtonModule, RouterLink, NbLayoutModule, PasswordSetComponent, TranslateModule]
})
export class NbResetPasswordComponent implements OnInit{

  showMessages = { error: true, success: true };

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];

  private resetCode = '';

  constructor( private apiService: ApiService,
              protected cd: ChangeDetectorRef,
              protected router: Router,
              private route: ActivatedRoute,
              public translate: TranslateService
            ) {

    // this.redirectDelay = this.getConfigValue('forms.resetPassword.redirectDelay');
    // this.showMessages = this.getConfigValue('forms.resetPassword.showMessages');
    // this.strategy = this.getConfigValue('forms.resetPassword.strategy');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.resetCode = params['code'] || '';
      if (!this.resetCode) {
        this.router.navigate(['/']);
      }
    });
  }

  async resetPass(password: string): Promise<void> {
    this.errors = [];
    this.messages = [];

    if (!this.resetCode) {
      this.errors = [this.translate.instant('auth.resetPassword.invalidLink')];
      this.cd.detectChanges();
      return;
    }

    this.submitted = true;

    try {
      await this.apiService.resetPassword(this.resetCode, password, password)
      this.messages = [this.translate.instant('auth.resetPassword.successMessage')]

      setTimeout(() => {
        this.router.navigate(['/userLogin'])
      }, 2000);
    } catch (error) {
      const message = error?.response?.data?.error?.message || error?.response?.data?.message || '';

      if(message === 'EINVALIDTOKEN'){
        this.errors = [this.translate.instant('auth.resetPassword.expiredLink')]
      } else if(message === 'ETOKENALREADYUSED'){
        this.errors = [this.translate.instant('auth.resetPassword.usedLink')]
      } else {
        this.errors = [this.translate.instant('auth.resetPassword.genericError')]
      }
    } finally {
      this.submitted = false;
      this.cd.detectChanges()
    }
  }

}
